import i18next from 'i18next';
const validateRequiredI18n = (value) => !value ? i18next.t('validation:required') : null;
export default validateRequiredI18n;
